import { Activity, Fragment } from 'react';
import { Box, Center, Group, Loader, Stack, Text } from '@mantine/core';
import { MChatMessage } from '@/src/modules/chat/models/chat-message';
import { formatDisplayShortDate } from '@/src/shared/utils/datetime';
import ChatMessagePaper from './chat-message-paper/chat-message-paper';

interface IChatMessageListProps {
  size?: 'sm' | 'md';
  messages: MChatMessage[];
  isLoadingMore?: boolean;
}

export function ChatMessageList({
  size = 'md',
  messages,
  isLoadingMore,
}: IChatMessageListProps) {
  const isNormalSize = size === 'md';

  const hasDifferentSentAtDateWithPreviousMessage = (index: number) => {
    const previousIndex = index - 1;
    if (previousIndex < 0) {
      return true;
    }

    const previousMessage = messages[previousIndex];
    const currentMessage = messages[index];
    return (
      currentMessage.props.sentAt.toDateString() !==
      previousMessage.props.sentAt.toDateString()
    );
  };

  return (
    <Stack gap={isNormalSize ? 'sm' : 'xs'} py="1rem">
      <Activity mode={isLoadingMore ? 'visible' : 'hidden'}>
        <Center mb="0.3rem">
          <Loader size="sm" />
        </Center>
      </Activity>

      {messages.map((message, index) => (
        <Fragment key={message.props.id}>
          {hasDifferentSentAtDateWithPreviousMessage(index) && (
            <Center mb="sm">
              <Text
                fz={isNormalSize ? 'xs' : '0.65rem'}
                bg="gray.3"
                py="0.2rem"
                px="0.6rem"
                bdrs="md"
              >
                {message.isSentToday
                  ? 'Hari ini'
                  : formatDisplayShortDate(message.props.sentAt)}
              </Text>
            </Center>
          )}

          <Group px="md" justify={message.props.fromMe ? 'end' : 'start'}>
            <Box maw="62%" w="fit-content">
              <ChatMessagePaper
                size={size}
                message={message}
                fromMe={message.props.fromMe}
              />
            </Box>
          </Group>
        </Fragment>
      ))}
    </Stack>
  );
}
